/**
 * Choice page data
 * Centralized location for easy maintenance and updates
 */

export const choiceOptions = [
  {
    id: 'guided',
    icon: '🎯',
    title: 'Guided Application (Recommended)',
    description: 'Complete assistance from start to finish with personalized guidance',
    features: [
      'Expert consultation & pathway planning',
      'Document preparation & review',
      'Application submission & tracking',
      'Visa interview preparation'
    ],
    cta: 'Start Guided Application',
    link: '/wizard',
    accent: 'blue',
    recommended: true
  },
  {
    id: 'consultation',
    icon: '💬',
    title: 'Free Consultation',
    description: 'Speak with our experts to understand your options',
    features: [
      '30-minute expert consultation',
      'Eligibility assessment',
      'Personalized recommendations',
      'Next steps guidance'
    ],
    cta: 'Book Free Consultation',
    link: '/contact',
    accent: 'purple'
  },
  {
    id: 'chat',
    icon: '🤖',
    title: 'AI Assistant',
    description: 'Get instant answers to your questions',
    features: [
      '24/7 AI-powered assistance',
      'Instant FAQ responses',
      'Document checklist generator',
      'Basic eligibility check'
    ],
    cta: 'Chat with AI Assistant',
    link: '/chat-n8n',
    accent: 'green'
  }
];

/**
 * Choice page highlights
 */
export const choiceHighlights = [
  {
    title: 'Free Assessment',
    value: '100%',
    description: 'No hidden costs',
    icon: '✅'
  },
  {
    title: 'Time to Complete',
    value: '6 min',
    description: 'Average wizard time',
    icon: '⏱️'
  },
  {
    title: 'Countries',
    value: '5',
    description: 'Germany, Canada, Australia, UK, NZ',
    icon: '🌍'
  },
  {
    title: 'Success Rate',
    value: '99%',
    description: 'For qualified applicants',
    icon: '🎯'
  }
];
